import apiSlice, { providesList } from "../../app/api/apiSlice";

export const recipientsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCurrentUserMailingGroups: builder.query({
			query: () => `/api/mailingGroups`,
			providesTags: () => {
				return [{ type: "MailingGroups", id: "LIST" }];
			},
		}),
		getGroupRecipients: builder.query({
			query: ({ groupId }) => `/api/mailingGroups/${groupId}`,
			transformResponse: (response, meta, arg) => {
				return (
					response.data &&
					response.data.map((d, index) => {
						return { lp: index + 1, ...d, groupId: arg.groupId };
					})
				);
			},
			providesTags: (result) => {
				return providesList(result || null, "Recipients");
			},
		}),
		addRecipientsToGroup: builder.mutation({
			query: ({ groupId, data }) => ({
				url: `/api/mailingGroups/${groupId}/contact`,
				method: "POST",
				body: { data },
			}),
			invalidatesTags: [{ type: "Recipients", id: "LIST" }],
		}),
		addRecipientsFromCSV: builder.mutation({
			query: ({ data }) => ({
				url: `/api/mailingGroups/import`,
				method: "POST",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Recipients", id: "LIST" }],
		}),
		removeRecipientsFromGroup: builder.mutation({
			query: ({ groupId, recipientId }) => ({
				url: `/api/mailingGroups/${groupId}/contact/${recipientId}`,
				method: "DELETE",
			}),
			invalidatesTags: [{ type: "Recipients", id: "LIST" }],
		}),
		editRecipient: builder.mutation({
			query: ({ groupId, recipientId, data }) => ({
				url: `/api/mailingGroups/${groupId}/contact/${recipientId}`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Recipients", id: "LIST" }],
		}),
		editGroupName: builder.mutation({
			query: ({ groupId, name }) => ({
				url: `/api/mailingGroups/${groupId}`,
				method: "PUT",
				body: { name },
			}),
			invalidatesTags: [
				{ type: "MailingGroups", id: "LIST" },
				{ type: "Cargos", id: "LIST" },
				{ type: "CompanyCargos", id: "LIST" },
			],
		}),
		addGroup: builder.mutation({
			query: ({ name }) => ({
				url: `/api/mailingGroups`,
				method: "POST",
				body: { name },
			}),
			invalidatesTags: [
				{ type: "MailingGroups", id: "LIST" },
				{ type: "Cargos", id: "LIST" },
				{ type: "CompanyCargos", id: "LIST" },
			],
		}),
		removeGroup: builder.mutation({
			query: ({ groupId }) => ({
				url: `/api/mailingGroups/${groupId}`,
				method: "DELETE",
			}),
			invalidatesTags: [
				{ type: "MailingGroups", id: "LIST" },
				{ type: "Cargos", id: "LIST" },
				{ type: "CompanyCargos", id: "LIST" },
			],
		}),
		// BLACKLIST
		getBlacklist: builder.query({
			query: () => `/api/blacklist`,
			transformResponse: (response) => {
				return (
					response.data &&
					response.data.map((d, index) => {
						return { lp: index + 1, ...d };
					})
				);
			},
			providesTags: (result) => {
				return providesList(result || null, "BlackList");
			},
		}),
		addRecipientsToBlacklist: builder.mutation({
			query: ({ data }) => ({
				url: `/api/blacklist/contact`,
				method: "POST",
				body: { data },
			}),
			invalidatesTags: [{ type: "BlackList", id: "LIST" }],
		}),
		removeRecipientsFromBlacklist: builder.mutation({
			query: ({ recipientId }) => ({
				url: `/api/blacklist/contact/${recipientId}`,
				method: "DELETE",
			}),
			invalidatesTags: [{ type: "BlackList", id: "LIST" }],
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetCurrentUserMailingGroupsQuery,
	useAddRecipientsToGroupMutation,
	useAddRecipientsFromCSVMutation,
	useRemoveRecipientsFromGroupMutation,
	useEditRecipientMutation,
	useEditGroupNameMutation,
	useGetGroupRecipientsQuery,
	useAddRecipientsToBlacklistMutation,
	useGetBlacklistQuery,
	useRemoveRecipientsFromBlacklistMutation,
	useAddGroupMutation,
	useRemoveGroupMutation,
} = recipientsApiSlice;
